var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoolicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4142 13.01L5.9992 11.597L10.5992 6.99699L5.9992 2.39699L7.4142 0.98999L13.4242 6.99999L7.4152 13.01H7.4142ZM1.9892 13.01L0.575195 11.597L5.1752 6.99699L0.575195 2.40399L1.9892 0.98999L8.0002 6.99999L1.9902 13.01H1.9892Z",
    fill: "#180101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoolicon);
export default __webpack_public_path__ + "static/media/coolicon.4afbe02f371d018c6c15e4f49976650d.svg";
export { ForwardRef as ReactComponent };